import axios from 'axios';
import {config} from '../../services/configService';

export default {
    /**
     * Update services
     *
     * @param {Array} services
     *
     * @return {Array}
     */
    async updateServices(services) {
        try {
            return await axios.post(config.cart.services, {services}).then(response => response.data);
        } catch {
            return [];
        }
    }
};